import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/usr/src/app/apps/storefront/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/apps/storefront/layouts/default.vue").then(m => m.default || m)),
  loading: defineAsyncComponent(() => import("/usr/src/app/apps/storefront/layouts/loading.vue").then(m => m.default || m))
}